import { CellData, TabData } from '@ddt-web/data-service';
import { StringUtil } from '@ddt-web/generic-utils';
import * as get from 'lodash/get';
import * as unzip from 'lodash/unzip';

export class BarDataUtil {
	public static getDefaultBarSeriesForTabData(data: TabData): Array<any> {
		const cellsData = unzip(data?.tableData?.[0]?.cells);
		const portfolios = data.displayConfig.transpose ? data.tableData[0].headersX : data.tableData[0].headersY;
		const categories = data.displayConfig.transpose ? data.tableData[0].headersY : data.tableData[0].headersX;
		return cellsData.map((row: Array<CellData>, index: number) => {
			return {
				name: portfolios[index].formattedValue,
				data: row
					.map((cellData: CellData, cellIndex: number) => {
						if (get(cellData, 'config.visible')) {
							const tooltip =
								`<div class="tooltip row text-12"><span class="col-16"><b>${StringUtil.escapeHtml(categories[cellIndex].formattedValue)}</b></span>` +
								`<span class="col-8 text-align-right">${StringUtil.escapeHtml(cellData.formattedValue)}</span></div>`;
							return {
								y: cellData.rawValue,
								tooltip: tooltip
							};
						} else {
							return null;
						}
					})
					.filter(row => row !== null)
			};
		});
	}
}
